module.exports = __webpack_public_path__ + "media/images/lb/341-8547aacf78bc071de3239c4dd6a6a9c7.svg";